import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

// https://webpack.js.org/guides/dependency-management/#requirecontext
const modulesFiles = require.context('./modules', true, /\.js$/);

// you do not need `import app from './modules/app'`
// it will auto require all vuex module from modules file
const modules = modulesFiles.keys().reduce((modules, modulePath) => {
  // set './app.js' => 'app'
  const moduleName = modulePath.replace(/^\.\/(.*)\.\w+$/, '$1');
  const value = modulesFiles(modulePath);
  modules[moduleName] = value.default;
  return modules;
}, {});

const store = new Vuex.Store({
  state: {
    userInfo: null, // 用户信息，接口获取

    // 权限信息
    permissions: null,

    // 活动信息
    webinarInfo: null,

    // 账号是否到期, 到期：true, 未到期：false
    versionExpired: null
  },
  mutations: {
    setUserInfo(state, data) {
      state.userInfo = data;
    },

    setPermissions(state, data) {
      state.permissions = data;
    },

    setWebinarInfo(state, data) {
      state.webinarInfo = data;
    },

    setVersionExpired(state, val) {
      state.versionExpired = val;
    }
  },
  modules
});

export default store;
